/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { BannerEl } from 'common/components/banner';
import { BannerSize, BannerTheme, BannerType } from 'common/components/banner/types';
export function AuthBanners(_ref: Partial<{
  success: string;
  info: string;
  error: string;
}>) {
  let {
    success,
    info,
    error
  }: Partial<{
    success: string;
    info: string;
    error: string;
  }> = _ref;
  if (!success && !info && !error) {
    return null;
  }
  return <div sel='.mp-auth-banner-container' data-sentry-component="AuthBanners" data-sentry-source-file="auth-banners.tsx">
      {success && <BannerEl attrs={{
      id: "".concat(BannerTheme.Success, "-banner"),
      theme: BannerTheme.Success,
      size: BannerSize.Small,
      type: BannerType.Embedded,
      'body-text': success
    }} />}
      {info && <BannerEl attrs={{
      id: "".concat(BannerTheme.Info, "-banner"),
      theme: BannerTheme.Info,
      size: BannerSize.Medium,
      type: BannerType.Embedded,
      'body-text': info
    }} />}
      {error && <BannerEl attrs={{
      id: "".concat(BannerTheme.Error, "-banner"),
      theme: BannerTheme.Error,
      size: BannerSize.Medium,
      type: BannerType.Embedded,
      'body-text': error
    }} />}
    </div>;
}